import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Loading from "../../../components/Loading";

class ExternalLoginADR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedirecting: true
    };
  }

  componentDidMount() {
    const timer = setTimeout(() => {
      const token = this.props.user.token;
      const redirectUrl = `https://login.educandus.com.br/external-auth?token=${token}&redirect=adr`;
      window.location.href = redirectUrl;
    }, 2000);

    this.redirectTimer = timer;
  }

  componentWillUnmount() {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }

  render() {
    const { isRedirecting } = this.state;

    if (isRedirecting) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center"
          }}
        >
          <Loading />
          <h4 style={{ marginTop: "20px", color: "#666" }}>
            Aguarde, você está sendo redirecionado...
          </h4>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalLoginADR);
